var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center ltr",staticStyle:{"width":"100%"}},[_c('span',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.systemBarDate))]),_c('span',[_vm._v(_vm._s(_vm.systemBarTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }